export default "__VITE_ASSET__FKqBj6El__"